var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M21.6045 2.25H7.27878C7.16138 2.2499 7.04511 2.27293 6.93661 2.31777C6.8281 2.3626 6.72949 2.42837 6.64641 2.51132C6.56332 2.59426 6.49739 2.69276 6.45237 2.80119C6.40735 2.90962 6.38413 3.02585 6.38403 3.14325V7.125L14.6858 9.5625L22.5 7.125V3.14325C22.4999 3.02579 22.4767 2.90949 22.4316 2.80102C22.3866 2.69254 22.3206 2.59401 22.2374 2.51105C22.1542 2.4281 22.0555 2.36234 21.9469 2.31755C21.8384 2.27276 21.722 2.2498 21.6045 2.25Z",
          fill: "#41A5EE",
        },
      }),
      _c("path", {
        attrs: {
          d: "M22.5 7.125H6.38403V12L14.6858 13.4625L22.5 12V7.125Z",
          fill: "#2B7CD3",
        },
      }),
      _c("path", {
        attrs: {
          d: "M6.38403 12V16.875L14.1975 17.85L22.5 16.875V12H6.38403Z",
          fill: "#185ABD",
        },
      }),
      _c("path", {
        attrs: {
          d: "M7.27878 21.75H21.6038C21.7213 21.7503 21.8377 21.7274 21.9464 21.6827C22.0551 21.6379 22.1539 21.5722 22.2371 21.4892C22.3204 21.4062 22.3864 21.3077 22.4316 21.1992C22.4767 21.0906 22.4999 20.9743 22.5 20.8568V16.875H6.38403V20.8568C6.38413 20.9742 6.40735 21.0904 6.45237 21.1988C6.49739 21.3072 6.56332 21.4057 6.64641 21.4887C6.72949 21.5716 6.8281 21.6374 6.93661 21.6822C7.04511 21.7271 7.16138 21.7501 7.27878 21.75Z",
          fill: "#103F91",
        },
      }),
      _c("path", {
        attrs: {
          opacity: "0.1",
          d: "M12.3255 6.15039H6.38403V18.3379H12.3255C12.5623 18.3367 12.789 18.2423 12.9567 18.0751C13.1243 17.9079 13.2193 17.6814 13.221 17.4446V7.04364C13.2193 6.80689 13.1243 6.58038 12.9567 6.41318C12.789 6.24598 12.5623 6.15157 12.3255 6.15039Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          opacity: "0.2",
          d: "M11.8373 6.6377H6.38403V18.8252H11.8373C12.074 18.824 12.3008 18.7296 12.4684 18.5624C12.636 18.3952 12.731 18.1687 12.7328 17.9319V7.53095C12.731 7.2942 12.636 7.06769 12.4684 6.90049C12.3008 6.73329 12.074 6.63887 11.8373 6.6377Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          opacity: "0.2",
          d: "M11.8373 6.6377H6.38403V17.8502H11.8373C12.074 17.849 12.3008 17.7546 12.4684 17.5874C12.636 17.4202 12.731 17.1937 12.7328 16.9569V7.53095C12.731 7.2942 12.636 7.06769 12.4684 6.90049C12.3008 6.73329 12.074 6.63887 11.8373 6.6377Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          opacity: "0.2",
          d: "M11.349 6.6377H6.38403V17.8502H11.349C11.5858 17.849 11.8125 17.7546 11.9802 17.5874C12.1478 17.4202 12.2428 17.1937 12.2445 16.9569V7.53095C12.2428 7.2942 12.1478 7.06769 11.9802 6.90049C11.8125 6.73329 11.5858 6.63887 11.349 6.6377Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M2.3955 6.6377H11.349C11.5862 6.6375 11.8137 6.73147 11.9816 6.89897C12.1496 7.06646 12.2441 7.29377 12.2445 7.53095V16.4694C12.2441 16.7066 12.1496 16.9339 11.9816 17.1014C11.8137 17.2689 11.5862 17.3629 11.349 17.3627H2.3955C2.27804 17.3629 2.16168 17.3399 2.05309 17.2951C1.9445 17.2504 1.84581 17.1846 1.76264 17.1016C1.67948 17.0187 1.61348 16.9202 1.56841 16.8117C1.52334 16.7032 1.5001 16.5869 1.5 16.4694V7.53095C1.5001 7.41348 1.52334 7.29719 1.56841 7.18871C1.61348 7.08023 1.67948 6.9817 1.76264 6.89875C1.84581 6.81579 1.9445 6.75004 2.05309 6.70525C2.16168 6.66045 2.27804 6.6375 2.3955 6.6377Z",
          fill: "url(#paint0_linear_476_32835)",
        },
      }),
      _c("path", {
        attrs: {
          d: "M5.17508 13.4908C5.19233 13.6288 5.20433 13.7488 5.20958 13.8516H5.23058C5.23808 13.7541 5.25458 13.6363 5.27933 13.4991C5.30408 13.3618 5.32583 13.2456 5.34608 13.1503L6.28733 9.09509H7.50533L8.48033 13.0896C8.53712 13.3367 8.5777 13.5872 8.60183 13.8396H8.61833C8.63624 13.5939 8.67006 13.3497 8.71958 13.1083L9.49883 9.08984H10.6066L9.23858 14.9008H7.94333L7.01558 11.0563C6.98858 10.9453 6.95808 10.8008 6.92408 10.6228C6.89008 10.4448 6.86908 10.3148 6.86108 10.2328H6.84533C6.83483 10.3273 6.81383 10.4676 6.78233 10.6536C6.75083 10.8403 6.72608 10.9776 6.70733 11.0676L5.83508 14.9031H4.51808L3.14258 9.09509H4.26758L5.11583 13.1586C5.14114 13.2683 5.16092 13.3792 5.17508 13.4908Z",
          fill: "white",
        },
      }),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear_476_32835",
                x1: "3.3705",
                y1: "5.9357",
                x2: "10.374",
                y2: "18.0647",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#2368C4" } }),
              _c("stop", { attrs: { offset: "0.5", "stop-color": "#1A5DBE" } }),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1146AC" } }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }